/**
 * Hook para manejar el estado de carga del badge
 *
 * Detecta cuando el badge termina de cargar (badgeLoading cambia de true a false)
 * y actualiza el estado correspondiente.
 */

import { useState, useEffect, useRef } from 'react';

/**
 * Hook que detecta cuando el badge termina de cargar
 *
 * @param badgeLoading - Estado actual de carga del badge
 * @returns true si el badge ha terminado de cargar (badgeLoading cambió de true a false)
 */
export const useBadgeLoading = (badgeLoading?: boolean) => {
  const [badgeFinishedLoading, setBadgeFinishedLoading] = useState(false);
  const previousBadgeLoadingRef = useRef<boolean | undefined>(badgeLoading);

  useEffect(() => {
    if (previousBadgeLoadingRef.current === true && badgeLoading === false) {
      setBadgeFinishedLoading(true);
    }
    previousBadgeLoadingRef.current = badgeLoading;
  }, [badgeLoading]);

  // Resetear cuando badgeLoading se activa (vuelve a true)
  useEffect(() => {
    if (badgeLoading === true) {
      setBadgeFinishedLoading(false);
    }
  }, [badgeLoading]);

  return badgeFinishedLoading;
};
